// Vendor imports
const React = require('react')

function usePrevious(value) {
  const ref = React.useRef()
  React.useEffect(() => {
    ref.current = value
  })
  return ref.current
}

module.exports = usePrevious
